<mat-card>
	<mat-card-header>
		<mat-card-title class="font-weight-normal">
			<div fxLayout="row" fxLayoutAlign="center center">
				<div class="font-size-16" fxFlex="100">
					Load Detail{{ customerName ? ' - ' + (customerName | titlecase) : '' }}
				</div>
			</div>
		</mat-card-title>
	</mat-card-header>
	<mat-divider></mat-divider>

	<app-default-progress-bar *ngIf="quote == null"></app-default-progress-bar>

	<mat-card-content *ngIf="quote != null">
		<app-column-details [dataSource]="detailsView"> </app-column-details>

		<div
			*ngIf="stopsDisplay.length"
			class="padding-0-5 font-size-16"
			fxLayout="row"
			fxLayoutAlign="top left"
			fxLayoutGap="1rem"
		>
			<div class="label-text-light textWithIcon" fxFlex="25">
				<mat-icon class="primary-light-color" style="margin-right: 1rem">place</mat-icon>
				<b>Stops</b>
			</div>
			<div class="label-text-light" fxFlex="75" fxLayoutAlign="start start">
				<button
					type="button"
					#stopsPopoverTrigger="mtxPopoverTrigger"
					[mtxPopoverTriggerFor]="stopsPopover"
					mtxPopoverTriggerOn="click"
					class="cursor-pointer text-underline primary-text stops-summary"
					[attr.aria-label]="stopsDisplay.length + ' stops'"
					(click)="$event.stopPropagation()"
				>
					{{ stopsDisplay.length }} stop{{ stopsDisplay.length === 1 ? '' : 's' }}
				</button>
			</div>
		</div>

		<mtx-popover #stopsPopover="mtxPopover" [closeOnPanelClick]="false">
			<div class="stops-popover" role="list">
				<div
					*ngFor="let stop of stopsDisplay"
					class="stops-popover-row"
					role="listitem"
					fxLayout="row"
					fxLayoutGap="1rem"
					fxLayoutAlign="space-between start"
				>
					<span class="stops-popover-sequence">{{ stop.sequence }}.</span>
					<span class="stops-popover-type">{{ stop.typeLabel }}</span>
					<span class="stops-popover-location" fxFlex>{{ stop.location }}</span>
					<span class="stops-popover-date">{{ stop.dateWindow }}</span>
				</div>
			</div>
		</mtx-popover>

		<div
			*ngIf="SHOW_LOAD_URL"
			class="padding-0-5 font-size-16"
			fxLayout="row"
			fxLayoutAlign="top left"
			fxLayoutGap="1rem"
		>
			<div class="label-text-light textWithIcon" fxFlex="25">
				<mat-icon class="primary-light-color" style="margin-right: 1rem">link</mat-icon>
				<b>Load URL</b>
			</div>
			<div class="label-text-light" fxFlex="75" fxLayoutAlign="start start">
				{{ LOAD_URL }}
			</div>
		</div>

		<div
			class="padding-0-5 font-size-16"
			fxLayout="row"
			fxLayoutAlign="top left"
			fxLayoutGap="1rem"
		>
			<div class="label-text-light textWithIcon" fxFlex="25">
				<mat-icon class="primary-light-color" style="margin-right: 1rem">edit</mat-icon>
				<b>Instructions</b>
			</div>
			<div class="label-text-light" fxFlex="75">
				<app-special-instructions-dialog
					[layoutAlign]="'center center'"
					[specialInstructions]="quote.specialInstructions"
				>
				</app-special-instructions-dialog>
			</div>
		</div>

		<div
			*ngIf="isEditQuote"
			class="padding-0-5"
			fxLayout="row"
			fxLayoutAlign="end end"
			fxLayoutGap="1rem"
		>
			<button
				(click)="$event.stopPropagation(); rerunLoad()"
				*ngIf="!isLoading"
				color="primary"
				mat-raised-button
				[matTooltipDisabled]="DIFFERENCE_FROM_NOW(quote.created, 'minutes') > 30"
				matTooltip="{{
					'Available in ' + (30 - DIFFERENCE_FROM_NOW(quote.created, 'minutes')) + ' minute(s)'
				}}"
				matTooltipClass="custom-tooltip"
				[disabled]="DIFFERENCE_FROM_NOW(quote.created, 'minutes') < 31 || rerunRequestSent"
			>
				Rerun Load
			</button>
			<mat-spinner [diameter]="30" *ngIf="isLoading"></mat-spinner>

			<app-post-load
				(updatedData)="quote = $event; quoteUpdated.emit($event); buildView()"
				[isEditQuote]="true"
				[quote]="quote"
			></app-post-load>

			<button
				*ngIf="canCancel"
				class="decline-background"
				mat-raised-button
				(click)="$event.stopPropagation(); cancelLoadClicked.emit()"
			>
				<mat-icon class="m-r-1 color-white">stop</mat-icon>
				<span>Cancel Load</span>
			</button>
		</div>
	</mat-card-content>
</mat-card>
